import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCarAlt, FaTruck, FaBoxes, FaExchangeAlt, FaQuestionCircle, FaStackExchange, FaGlobeAfrica, FaCreditCard } from 'react-icons/fa';
import Sidebar from '../../composant_reutilisable/sidebar';
import Navbar from '../../composant_reutilisable/navbar';
import useAuth from '../../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import GlossaireSidebar from '../../composant_reutilisable/glossaireSidebar';
import Pas_acces from '../../composant_reutilisable/pas_acces';
import axios from 'axios';
import Footer from '../../composant_reutilisable/footer';

const Gestion_des_tours = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];



    const [userData, setUserData] = useState({});
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(
                    process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`
                );
                if (response.ok) {
                    const data = await response.json();
                    setUserData(data);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération du profil:", error);
            }
        };

        fetchUserData();
    }, [user_id]);



    const [parcs, setParcs] = useState([]);
    const fetchParcs = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                console.log(data)
                setParcs(data);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Gestion des tours";
        }
        fetchParcs()
    }, [user_id]);


    const hasNationalAccess = () => {
        if (!userData?.parc || parcs.length === 0) return false;

        return parcs.some(
            (parc) => parc.type_parc === "national" && parc.ref_parc === userData.parc
        );
    };

    const hasInterNationalAccess = () => {
        if (!userData?.parc || parcs.length === 0) return false;

        return parcs.some(
            (parc) => parc.type_parc === "international" && parc.ref_parc === userData.parc
        );
    };

    const hasfretAccess = () =>
        userData?.parc && parcs.length > 0 &&
        parcs.some((parc) => parc.ref_parc === userData.parc);



    // Définition des éléments de menu simplifiés
    const baseMenuItems = [
        { icon: <FaBoxes />, text: 'Réservation de transport', link: '/Liste-declaration-fret', accessKey: 'Fret' },
        { icon: <FaExchangeAlt />, text: 'Fret domestique', link: '/Gestion-des-tours-national', accessKey: 'Mise_en_file' },
        { icon: <FaGlobeAfrica />, text: 'Fret en transit', link: '/Gestion-des-tours-international', accessKey: 'Mise_en_file' },
    ];

    let menuItems = baseMenuItems;

    // On ne fait le contrôle que si userData.parc est défini
    if (userData.parc !== "Non affecté") {
        menuItems = baseMenuItems.filter((item) => {
            if (item.text === "Fret domestique") {
                return hasNationalAccess();
            }
            if (item.text === "Fret en transit") {
                return hasInterNationalAccess();
            }
            if (item.text === "Réservation de transport") {
                return hasfretAccess();
            }
            return true;
        });
    }

    const handleClick = (lien) => {
        navigate(lien);
    };

    const userHasAccess = (accessKey) => {
        return accesGroupe.includes(accessKey);
    };

    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);



    useEffect(() => {
        if (accesGroupes.length > 0 && userData?.parc && parcs.length > 0) {
            // Si pas d'accès Fret
            if (!accesGroupes.includes("Fret")) {
                if (accesGroupes.includes("Mise_en_file") && hasNationalAccess()) {
                    navigate("/Gestion-des-tours-national");
                } else if (accesGroupes.includes("Mise_en_file") && hasInterNationalAccess()) {
                    navigate("/Gestion-des-tours-international");
                } else if (accesGroupes.includes("Fret") && hasfretAccess()) {
                    navigate("/Liste-declaration-fret");
                }
            }
        }
    }, [accesGroupes, userData, parcs, navigate]);

    if (
        !accesGroupes.includes("Fret") &&
        !accesGroupes.includes("Mise_en_file")
    ) {
        return <Pas_acces />;
    }


    // if (userData?.parc === "Non affecté") {
    //     return (
    //         <div id="wrapper">
    //             <Sidebar user_id={user_id} />
    //             <div id="page-wrapper" className="gray-bg">
    //                 <Navbar />
    //                 <div className="wrapper wrapper-content text-center mt-5">
    //                     <div className="alert alert-warning mx-auto" style={{ maxWidth: "600px" }}>
    //                         <h4 className="text-danger">Aucun parc assigné</h4>
    //                         <p>
    //                             Vous n’avez pas encore été affecté à un parc.<br />
    //                             Veuillez contacter un administrateur pour obtenir une affectation.
    //                         </p>
    //                         <button
    //                             className="btn btn-primary mt-3"
    //                             onClick={() => navigate("/Menu")}
    //                         >
    //                             Retour à l’accueil
    //                         </button>
    //                     </div>
    //                 </div>
    //                 <Footer />
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaExchangeAlt size={25} className='mr-2' /> Mise en file
                                </div>

                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation', {
                                        state: {
                                            fromModule: 'gestion-tours',
                                            fromSection: ''
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button>
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={`/Gestion-des-tours`}>Mise en file</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
                        <div className="row mx-auto justify-content-center">

                            {/* ✅ Message d’avertissement si non affecté */}
                            {userData?.parc === "Non affecté" && (
                                <div className="alert alert-warning mx-auto" style={{ maxWidth: "600px" }}>
                                    <h4 className="text-danger">Aucun parc assigné</h4>
                                    <p>
                                        Vous n’avez pas encore été affecté à un parc.<br />
                                        Veuillez contacter un administrateur pour obtenir une affectation.
                                    </p>
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={() => navigate("/Menu")}
                                    >
                                        Retour à l’accueil
                                    </button>
                                </div>
                            )}


                            {/* {menuItems.map((item, index) => (
                                userHasAccess(item.accessKey) && (
                                    <div key={index} className="col-md-2 mb-4">
                                        <div
                                            className="card rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center"
                                            onClick={() => handleClick(item.link)}
                                            style={{
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                        >
                                            <div className="card-body">
                                                <div className="mb-3 icon-small">{item.icon}</div>
                                                <h5><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))} */}
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default Gestion_des_tours;